(function() {
    var boundModel = function (linkWrapper) {
        var mentionBox = new MentionBoxViewModel();
        ko.applyBindings(mentionBox, linkWrapper);
    };

    var MentionBoxViewModel = function () {
        var mentionBox = this;
        mentionBox.mention = new MentionViewModel();
        var mentionStatus = mentionBox.mention.status;

        this.showMention = function (mentionBox, event) {

            var $tooltip = $(event.currentTarget).find('.mention-tooltip');
            $tooltip.removeClass('mention-tooltip_right-side mention-tooltip_below');
            backOnScreen($tooltip);

            mentionStatus.hidden(false);
            if (mentionStatus.ready() || mentionStatus.loading()) {
                mentionStatus.hidden(false);
            }
            else {
                mentionStatus.loading(true);
                var url = $(event.currentTarget).find('.mention__action-link').data('firm-data');
                mentionBox.mention.getDataFromServer(url);
            }
        };

        this.hideMention = function (mentionBox, event) {
            mentionStatus.hidden(true);
        };
    };

    var MentionViewModel = function () {
        var mention = this;

        _(mention).extend({
            name: ko.observable(),
            city: ko.observable(),
            last_visit: ko.observable(),
            avatar_src: ko.observable(),
            url: ko.observable(),
            counters: ko.observableArray([
                {
                    count: ko.observable(),
                    url: ko.observable(),
                    nameString: ko.observable('Отзывы'),
                    name: 'reviews',
                    GAE: {
                        category: 'Firm',
                        label: 'Click on reviews',
                        action: 'Forum post firm overlay'
                    }
                },
                {
                    count: ko.observable(),
                    url: ko.observable(),
                    nameString: ko.observable('Выбор невест'),
                    name: 'favorites',
                    GAE: {
                        category: 'Firm',
                        label: 'Click on favourites',
                        action: 'Forum post firm overlay'
                    }
                },
                {
                    count: ko.observable(),
                    url: ko.observable(),
                    nameString: ko.observable('Коллекции'),
                    name: 'ideabooks',
                    GAE: {
                        category: 'Firm',
                        label: 'Click on ideabooks',
                        action: 'Forum post firm overlay'
                    }
                },
                {
                    count: ko.observable(),
                    url: ko.observable(),
                    nameString: ko.observable('Активность'),
                    name: 'activity_posts',
                    GAE: {
                        category: 'Firm',
                        label: 'Click on activity',
                        action: 'Forum post firm overlay'
                    }
                }
            ])
        });

        mention.status = {
            loading: ko.observable(false),
            hidden: ko.observable(true),
            ready: ko.observable(false)
        };

        mention.styles = ko.computed(function () {
            if (mention.status.hidden()) {
                return '';
            }
            else if (mention.status.ready()) {
                return 'mention-tooltip_shown';
            }
            else if (mention.status.loading()) {
                return 'mention-tooltip_loading';
            }
        }, mention);

        mention.insertDataToModel = function (data) {
            mention.name(data.name);
            mention.city(data.city);
            mention.url(data.url);
            mention.avatar_src(data.avatar_src);
            mention.last_visit(data.last_visit.replace(/(&nbsp;)+/g," "));

            _(mention.counters()).each(function (counter) {
                var counterData = _(data.counters).findWhere({name: counter.name});
                counter.count(counterData.count);
                counter.url(counterData.url);
            });

            mention.status.loading(false);
            mention.status.ready(true);
        };

        mention.getDataFromServer = function (url) {
            $
            .getJSON(url)
            .always(function () {
                mention.status.loading(false);
            })
            .fail(function () {
                mention.status.failed(true);
            })
            .done(mention.insertDataToModel);
        };

        mention.avatar = ko.computed(function () {
            var src = mention.avatar_src();
            return src ? src : '';
        }, mention);

        mention.sendGAEvent = function (counter) {

            if ('undefined' !== typeof window.Tracker) {
                window.Tracker.pushEvent(counter.GAE);
            }

            return true;
        };

        return mention;
    };

    var headerHeight;

    var backOnScreen = function ($mention) {
        var viewportWidth = $(window).width();
        var viewportScrollTop = $(window).scrollTop() + headerHeight;

        var mentionTopOffset = $mention.offset().top;
        var mentionLeft = $mention.offset().left + $mention.width();

        if (viewportWidth <= $mention.width()) {
            return false;
        }

        if (viewportWidth <= mentionLeft) {
            $mention.addClass('mention-tooltip_right-side');
        }

        if (viewportScrollTop >= mentionTopOffset) {
            $mention.addClass('mention-tooltip_below');
        }
    };

    $(document).on('ready', function () {

        var $header = $('.header');

        if ($header.length > 0) {
            headerHeight = $header.height();
        } else {
            headerHeight = 0;
        }


        _($('.mention')).each(boundModel);

        $('.mention__action-link').on('click', function(event) {
            event.preventDefault();
        });

        _($('.mention-tooltip')).each(function (element) {
            backOnScreen($(element));
        });

        /// Костыли для закрашивания треугольника у плашки

        $('.mention__link:first-child')
        .on('mouseover', function () {
            $(this).closest('.mention-tooltip').addClass('mention-tooltip_hovered-corner-left');
        })
        .on('mouseout', function () {
            $(this).closest('.mention-tooltip').removeClass('mention-tooltip_hovered-corner-left');
        });

        $('.mention__link:last-child')
        .on('mouseover', function () {
            var $tooltip = $(this).closest('.mention-tooltip');
            if ($tooltip.hasClass('mention-tooltip_right-side')) {
                $tooltip.addClass('mention-tooltip_hovered-corner-right');
            }
        })
        .on('mouseout', function () {
            var $tooltip = $(this).closest('.mention-tooltip');
            if ($tooltip.hasClass('mention-tooltip_right-side')) {
                $tooltip.removeClass('mention-tooltip_hovered-corner-right');
            }
        });

        $('.tooltip .author__user')
            .on('mouseover', function () {
                var $tooltip = $(this).closest('.mention-tooltip');
                $tooltip.addClass('mention-tooltip_hovered-corner-top');
            })
            .on('mouseout', function () {
                var $tooltip = $(this).closest('.mention-tooltip');
                if ($tooltip.hasClass('mention-tooltip_hovered-corner-top')) {
                    $tooltip.removeClass('mention-tooltip_hovered-corner-top');
                }
            });
    });

})();
